import { render } from "./ShowPage.vue?vue&type=template&id=6c9fb61e"
import script from "./ShowPage.vue?vue&type=script&lang=js"
export * from "./ShowPage.vue?vue&type=script&lang=js"

import "./ShowPage.vue?vue&type=style&index=0&id=6c9fb61e&lang=scss"
script.render = render

export default script